import React, { useState, useEffect } from 'react';
import {
    Box,
    Heading,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    FormControl,
    FormLabel,
    Input,
    HStack,
    IconButton,
    useToast,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Text,
    Button,
} from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import PredioDetail from './Predio/PredioDetalle';
import { FaPlus } from 'react-icons/fa';
import PropietarioDetails from './Propietarios/PropietarioView';

const PropietarioTesoreria: React.FC = () => {
    const [transactions, setTransactions] = useState([]);
    const [selectedPredioId, setSelectedPredioId] = useState<string | null>(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const toast = useToast();

    const fetchTransactions = async () => {
        try {
            const response = await fetch(
                `http://52.91.130.91:5000/api/propietarios?page=${page}&pageSize=${pageSize}&search=${searchQuery}`
            );
            const data = await response.json();
            setTransactions(data.data);
            setTotalPages(data.pagination.totalPages);
        } catch (error) {
            toast({
                title: 'Error',
                description: 'No se pudieron cargar los datos.',
                status: 'error',
                duration: 3000,
                isClosable: true,
            });
        }
    };

    useEffect(() => {
        fetchTransactions();
    }, [page, pageSize, searchQuery]);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        setPage(1);
    };

    // Manejador para abrir el modal con el id del predio seleccionado
    const handleRowClick = (id: string) => {
        setSelectedPredioId(id);
       // alert(id)
        setModalOpen(true);
    };

    // Cerrar el modal y limpiar el id seleccionado
    const closeModal = () => {
        setModalOpen(false);
        setSelectedPredioId(null);
    };

    const handleOpenModal = () => {
        setSelectedPredioId(null);

        setModalOpen(true);
    }

    return (
        <Box p={8} bg="gray.50" borderRadius="md" boxShadow="md" maxW="1200px" mx="auto" mt={8}>
            <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
                Propietarios - Tesorería
            </Heading>

            <FormControl id="search" mb={4}>
        
        <HStack>
          <Input placeholder="Buscar..." value={searchQuery} onChange={handleSearch} />
          <Button colorScheme="teal" leftIcon={<FaPlus />} onClick={handleOpenModal}>
            Nuevo
          </Button>
        </HStack>
      </FormControl>

            <Box overflowX="auto">
                <Table variant="simple" size="md">
                    <Thead>
                        <Tr>
                            <Th>ID Sys.</Th>
                            <Th>Nombre</Th>
                            <Th>Apellido Paterno</Th>
                            <Th>Apellido Materno</Th>
                            <Th>RFC</Th>
                            <Th>CURP</Th>
                            <Th>TELEFONO</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {transactions.map((transaction: any, index) => (
                            <Tr key={index} onClick={() => handleRowClick(transaction.id)} style={{ cursor: 'pointer' }}>
                                <Td>{transaction.id}</Td>
                                <Td>{transaction.nombre}</Td>
                                <Td>{transaction.primerApellido}</Td>
                                <Td>{transaction.segundoApellido}</Td>
                                <Td>{transaction.rfc}</Td>
                                <Td>{transaction.curp}</Td>
                                <Td>{transaction.telefono}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>

            <HStack spacing={4} mt={4} justifyContent="center">
                <IconButton
                    icon={<ChevronLeftIcon />}
                    onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                    isDisabled={page === 1}
                    aria-label="Página anterior"
                />
                <Box>Página {page} de {totalPages}</Box>
                <IconButton
                    icon={<ChevronRightIcon />}
                    onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                    isDisabled={page === totalPages}
                    aria-label="Página siguiente"
                />
            </HStack>

            {/* Modal para Detalles del Predio */}
            <Modal isOpen={isModalOpen} onClose={closeModal} size="4xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalCloseButton />
                    <ModalBody>
                            <PropietarioDetails propietarioId={selectedPredioId} />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" onClick={closeModal}>Cerrar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default PropietarioTesoreria;
